import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {
  getAvailableLanguages,
  getLanguage,
  getMarketLanguage,
  getMarketAvailableLangauge,
  getConfigs,
  getMarketConfig
} from '../../features/app/selectors';
import {
  setLanguage,
  setReviewMarketLanguage
} from '../../features/app/actions';

import { toJS } from 'utils/immutableUtils';

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 100,
    marginLeft: theme.spacing(1)
  },
  root: {
    ...theme.typography.button,
    paddingLeft: theme.spacing(1)
  }
}));

const LanguageSelect = ({ visible = true, marketLanguage }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const langauageLabels = useSelector(getConfigs).toJS().languageDisplayLabels;
  const marketConfig = useSelector(getMarketConfig);
  const marketLangauageLabels = toJS(marketConfig, []);
  const availableLanguage = useSelector(getAvailableLanguages).toJS();
  const languages = useSelector(getLanguage);
  const availableMarketLanguages = useSelector(getMarketAvailableLangauge);
  const marketLanguages = useSelector(getMarketLanguage);
  const language = marketLanguage ? marketLanguages : languages;
  const availableLanguages = marketLanguage
    ? availableMarketLanguages
    : availableLanguage;
  if (!visible || availableLanguages.length === 1) {
    return null;
  }

  const handleChange = event => {
    if (marketLanguage) {
      dispatch(setReviewMarketLanguage(event.target.value));
    } else {
      dispatch(setLanguage(event.target.value));
    }
  };

  function createLanguageDisplayLabel(data) {
    const result = {};
    data.forEach(i => {
      result[i.languageCode] = i.displayLabel;
    });
    return result;
  }

  const displayLabels = marketLanguage
    ? createLanguageDisplayLabel(marketLangauageLabels.languageDisplayLabels)
    : createLanguageDisplayLabel(langauageLabels);

  return (
    <FormControl className={classes.formControl}>
      <Select
        value={language}
        onChange={handleChange}
        displayEmpty
        name="languageSelect"
        disableUnderline
        classes={{ root: classes.root }}
      >
        {availableLanguages.map(lang => (
          <MenuItem key={lang} value={lang}>
            {/* <FormattedMessage id={`internationalization.${lang}`} /> */}
            {displayLabels[lang]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

LanguageSelect.propTypes = {
  visible: PropTypes.bool
};

export default LanguageSelect;
